"use strict";
/**
 * @author Meiblorn (Vadim Fedorenko) <meiblorn@gmail.com | admin@meiblorn.com> on 12/05/16.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("./fullpage/index");
var index_2 = require("./fullpage/index");
exports.MnFullpageModule = index_2.MnFullpageModule;
exports.MnFullpageDirective = index_2.MnFullpageDirective;
exports.MnFullpageOptions = index_2.MnFullpageOptions;
exports.MnFullpageService = index_2.MnFullpageService;
exports.MN_FULLPAGE_DIRECTIVES = [index_1.MnFullpageDirective];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/~/ngx-fullpage/components/index.js
// module id = ../../../../ngx-fullpage/components/index.js
// module chunks = 4